import { PrimaryTextColor, primaryWhiteColor, boldFont, getRelativeFontSize,theme, mediumFont, heading, primaryBlueColor, primaryRedColor, regularFont, subHeading, borderColor, PrimaryLightTextColor } from "../../../../utils/styles";

const ShowAllStyles = {
  headerWrapper: {
    padding: "0 20px",
  },
  pageHeading: {
    ...heading,
  },

  autoInputFill: {
    "& .MuiFormHelperText-root.Mui-error": {
      color: "#d32f2f",
      fontSize: getRelativeFontSize(-3),
      ...regularFont,
      marginLeft: "5px",
      marginBottom: "5px",
    },
    "& .MuiAutocomplete-inputFocused": {
      fontSize: getRelativeFontSize(-3),
    },
    "& .css-t3lsui-MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input":{
      padding: "2px 5px",
      fontSize: getRelativeFontSize(-3),
    },
  },
  content: {
    padding: "0 70px",
  },
  checkBoxWarapper: {
    diplay: "flex",
    marginTop: "10px",
  },
  pageSubHeading: {
    ...subHeading,
  },
  statusHeading: {
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(),
    ...mediumFont,
  },
  showAllWrapper: {
    "& .MuiDataGrid-columnHeaderTitle":{
      ...boldFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(0),
    textTransform: "capitalize",
    },
    "& .MuiTablePagination-root":{
      ...regularFont,
      color: PrimaryTextColor,
      fontSize: getRelativeFontSize(0),

      "& .MuiTablePagination-selectLabel":{
        fontSize: getRelativeFontSize(0),
      },
      "& .MuiTablePagination-displayedRows":{
        fontSize: getRelativeFontSize(0),
      },
      
    },
    "& .MuiDataGrid-toolbarContainer":{
      ...regularFont,
      fontSize: getRelativeFontSize(0),

      "& .MuiInputBase-root":{
        ...regularFont,
        fontSize: getRelativeFontSize(0),

        "& .MuiSvgIcon-root":{
          fontSize:"1.2rem",
        },
      },
      "& .MuiButtonBase-root":{
        ...regularFont,
        fontSize: getRelativeFontSize(0),

        "& .MuiButton-startIcon":{
          marginRight:"0.313rem",
          marginLeft:"0",

          "& .MuiSvgIcon-root":{
            fontSize:"1.2rem",
          },
        },
      },
    },
    "& .MuiStack-root>:not(style):not(style)":{
      marginTop:"0",
    },
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "flex-start",
    gap: "5px",
    flexDirection: "column",
    "& button": {
      color: primaryBlueColor,
      height: "10px",
      fontSize: getRelativeFontSize(-2),
    },
  },
  buttonArea: {
    display:"flex",
    alignItems:"center",
    justifyContent:"end",

    "& button":{
      width:"auto",
      minWidth:"150px",
    },
  },

  verticalDotButton: {
    "& button": {
      "&:hover": {
        background: "none",
      },
    },
  },

  autocomplateStyle: {
    width: "100%",
    maxHeight:'38px',
    background: "#e7e7e7",
    "& .MuiSvgIcon-root ":{
      display:"none"
    },
    "& .MuiInputBase-input": {
      color: PrimaryTextColor,
      ...regularFont,
      fontSize: getRelativeFontSize(2),
      "&::placeholder": {
        ...regularFont,
        fontSize: getRelativeFontSize(-1),
        color: PrimaryLightTextColor,
      },
    },
    "&  .MuiOutlinedInput-root": {
      padding: "0.5px 9px",
    },
    "&  .MuiTextField-root": {
      maxHeight:'38px',
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "4px",
      display:'flex',
      flexWrap: "initial",
      overflow:'hidden',
      "&.Mui-focused fieldset": {
        borderColor: "#E7E7EA",
      },
      "&:hover fieldset": {
        borderColor: "#E7E7EA",
      },
    },
    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
      borderColor: "#E7E7EA",
    },
    "& .MuiChip-label":{
      fontSize:"11px",
      padding:"0 8px",
    },
    "& .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium":{
      fontSize:"16px",
    },
  },
  buttonWrapperDialog: {
    width: "350px",
    display: "flex",
    justifyContent: "flex-start",
    gap: "10px",
    "& button": {
      color: primaryBlueColor,
      fontSize: getRelativeFontSize(-2),
      "&:nth-child(1)": {
        color: "#ffffff",
      },
    },
  },

  subHeaderName: {
    ...regularFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-2),
    textTransform: "capitalize",
  },
  dipt: {
    color: "#6D6E82",
    ...boldFont,
  },
  
  headerName: {
    ...boldFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-2),
    textTransform: "capitalize",
  },
  
  emp_type_btn: {
    background: "#18CB8A",
    width: "60px",
    height: "18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: getRelativeFontSize(-4),
    textTransform: "capitalize",
    ...regularFont,
    borderRadius: "4px",
    color: "#ffffff",
  },

  activeBtn: {

    "& button": {
      height: "32px",
      width: "70px",
      background:"#2e7d32",
      borderColor:"#2e7d32",
      color: primaryWhiteColor,
      fontSize: getRelativeFontSize(-4),
      ...mediumFont,
      "&:hover": {
        background:primaryWhiteColor,
        color:"#2e7d32",
      },
    },
  },

  deActive: {
    "& button": {
      height: "32px",
      width: "70px",
      fontSize: getRelativeFontSize(-4),
      ...mediumFont,
      background: "red",
      borderColor: "red",
      "&:hover": {
        background:primaryWhiteColor,
        color:"red",
      },
    },
  },

  idMap: {
    "& button": {
      height: "32px",
      width: "70px",
      fontSize: getRelativeFontSize(-4),
      ...mediumFont,
      background: "grey",
      borderColor: "grey",
      "&:hover": {
        background:primaryWhiteColor,
        color:"grey",
      },
    },
  },
  assignButton:{
    "& .assignBtn":{
      height: "32px",
      width: "70px",
      ...boldFont,
      fontSize: getRelativeFontSize(-2),
      textTransform:"capitalize",
      background:"#4ca2be",
      border:"1px solid #4ca2be",
      borderRadius:"4px",
      color: primaryWhiteColor,
      cursor:"pointer",

      "&:hover": {
        background:primaryWhiteColor,
        color:"#4ca2be",
      },
    },
  },

  popOverContent: {
    position: "relative",
    top: "20px",
  },

  popOverBtn: {
    position: "absolute",
  },

  Info_btn: {
    height: "18px",
    width: "fit-content",
    padding: "0 10px",
    ...regularFont,
    borderRadius: "4px",
    background: "#F4BE5E",
    fontSize: getRelativeFontSize(-4),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "5px",
    color: "#ffffff",
    textTransform: "capitalize",
  },

  filterButton: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    justifyContent: "center",
    height: "46px",
  },

  filterName: {
    ...mediumFont,
    fontSize: getRelativeFontSize(2),
    color: "#11142D",
    "& img": {
      marginLeft: "10px",
    },
  },
  dataGridContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  columnHeaders: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: "#fff",
  },
  virtualScroller: {
    overflowY: "auto", 
    maxHeight: "calc(100vh - 306px)",
  },
  popUpBox:{
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "500px",
    height: "380px",
    margin:"0 auto",
    backgroundColor: primaryWhiteColor,
    border: "1px solid #e0e0e0",
    borderRadius:"4px",
    boxShadow:"",
    padding:"20px",

    "& .heading":{
      ...boldFont,
      fontSize : getRelativeFontSize(4),
      marginBottom:"0.5em",
    },
    "& .teamArea":{
      display:"flex",
      alignItems:"center",
      gap:"1rem",

      "& .teamName":{
        ...boldFont,
        fontSize : getRelativeFontSize(0),
        color:PrimaryTextColor,
      },
      "& .memberNameArea":{
        display:"flex",
        alignItems:"center",
        gap:"0.5rem",
        

        "& .memberName":{
          ...regularFont,
          fontSize : getRelativeFontSize(0),
          color:PrimaryTextColor,
          overflowY: "auto"
        },
      },
    },
  },
  gridRow:{
    border: "none",
    "& .MuiDataGrid-columnHeaders": {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: "#fff",
    },
    "& .MuiDataGrid-virtualScroller": {
      overflowY: "auto", 
    maxHeight: "calc(100vh - 338px)",
    scrollbarWidth:"thin"
    },
    "& .MuiDataGrid-virtualScrollerRenderZone":{
      fontSize:"14px"
    },
    "& .MuiDataGrid-cell":{
fontSize:"14px"
    },
    "& .MuiDataGrid-footerContainer":{
      minHeight:"0px"
    }
  },
};

export default ShowAllStyles;
